import React, { useState, ReactNode, useRef } from 'react';

type ButtonProps = {
  forceActive?: boolean;
  onHover?: (isHovered: boolean) => void;
  children: (active: boolean) => ReactNode;
};

function Hoverable({ children, forceActive, onHover }: ButtonProps) {
  const [activeHover, setActiveHover] = useState(false);
  // const [deactivate, setDeactivate] = useState(false);
  const deactivateDelayer = useRef<boolean>();
  return (
    <div
      onMouseEnter={() => {
        if (onHover) {
          onHover(true);
        }
        setActiveHover(true);
        deactivateDelayer.current = true;
      }}
      onMouseLeave={() => {
        // We add there small delay in case user accidentaly go outside and then back into the menu
        deactivateDelayer.current = false;
        if (onHover) {
          onHover(false);
        }
        setTimeout(() => {
          if (deactivateDelayer.current === false) {
            setActiveHover(false);
          }
        }, 150);
      }}
      style={{ position: 'relative', width: '100%' }}
    >
      {children(forceActive || activeHover)}
    </div>
  );
}

export default Hoverable;
